import React, { Children } from 'react';

import { useAppSelector } from '@/store';
import { DataElementContext } from '../common/DataElementContext';
import { PageDataContext } from '@/components/utils/PageDataProvider';

export const defaultProps = {
  properties: {
    componentId: null,
  },
  visibility: {},
};

export const NamedSlot = (componentProps) => {
  const dataElementContext = React.useContext(DataElementContext);
  const pageDataContext = React.useContext(PageDataContext);
  const components = useAppSelector((state) => state.templatesConfig.components);

  const context = React.useMemo(() => {
    return {
      ...(pageDataContext?.parentDataElementContext ?? {}),
      slotDataContext: dataElementContext,
    };
  }, [dataElementContext, pageDataContext?.parentDataElementContext]);

  if (!componentProps.children) return null;

  return (
    <PageDataContext.Provider value={pageDataContext.parent}>
      <DataElementContext.Provider value={context}>{componentProps.children}</DataElementContext.Provider>
    </PageDataContext.Provider>
  );
};
